import { ProductSummary, Status } from "features/catalogue/types";
import { TypeKeys as EditTypeKeys } from "./edit";
import { scaffoldList } from "common/scaffolding/reducers/scaffoldList";
import { sortByDisplayName } from "foundation/dataConventions/sortByDisplayName";
import { PublishSuccessAction, TypeKeys as PublishTypeKeys } from "features/location/reducers/publish";

enum TypeKeys {
    LOADING = "MENUITEMLIST/LOADING",
    LOADED = "MENUITEMLIST/LOADED",
    FAILED = "MENUITEMLIST/FAILED",
}

const list = scaffoldList<ProductSummary, typeof TypeKeys, typeof EditTypeKeys>(
    TypeKeys,
    EditTypeKeys,
    sortByDisplayName
);
const { createAction, reducer: scaffoldReducer } = list;

export type State = ReturnType<typeof list.reducer>;
type ReducerParams = Parameters<typeof list.reducer>;
type ReducerActions = ReducerParams[1];

function reducer(state: State, action: ReducerActions | PublishSuccessAction): State {
    if (action.type === PublishTypeKeys.SUCCESS) {
        if (state.status !== "loaded") {
            return state;
        }

        return {
            ...state,
            data: state.data.map((item) => {
                const wasPublished = !!action.result.menuData.items[item.id];

                if (!wasPublished) {
                    if (item.status === Status.Staged) {
                        return {
                            ...item,
                            status: Status.NotPublished,
                        };
                    }
                    return item;
                }

                return {
                    ...item,
                    status: Status.Published,
                };
            }),
        };
    }

    return scaffoldReducer(state, action);
}

export { createAction, reducer };
